import { Dialog } from 'primereact/dialog';
import classes from './ndcEditModal.module.scss';

import LockIcon from 'assets/icons/lockIcon.svg';
import MinusIcon from 'assets/icons/minusIcon.svg';
import {
  NDCEditFormDropDownResponseInterface,
  NDCFormFieldsTypes,
} from 'Interfaces/FactsInterfaces/drugInterfaces';
import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { DateConversionUtility, getNextMonthFirstDay, getTomorowsDate } from 'utils/dateUtilities';
import { checkIfNDCStrategyEditEnabled } from 'utils/facts/roleBasedFunctionalityAccess';
import ExtendedNdcSuccessPopup from './components/extendedNdcSuccessPopUp/extendedNdcSuccessPopUp';
import NdcHistoryTable from '../ndcHistoryTable/NdcHistoryTable';
import { useNdcStrategyEditModal } from './useNdcStrategyEditModal';

const NDCEditModal = ({
  visibility,
  toggleVisibility,
}: {
  visibility: boolean;
  toggleVisibility: () => void;
}) => {
  const {
    userModulesRoles,
    ndcFormDropDownData,
    isNcdTableLoading,
    isNdcUpdating,
    checkIfDropdownOptionDisabled,
    isAnyStrategySelected,
    handleStrategySelect,
    handleUnselectStrategy,
    allDropdownOptions,
    selectedNdcRowData,
    isNdcHistoryLoading,
    isHistoryVisible,
    initialNdcStrategyIndividualEditData,
    toggleHistoryVisibility,
    convertNdcFormDataToAllOptions,
    extendedSuccessPopUpVisibility,
    errorDetails,
    ndcStrategyIndividualEditData,
    formUpdateMethods,
    formFieldsArrayConverter,
    selectedOption,
    toggleExtendSuccessNdcPopUpVisibility,
    extendedSuccessPopUpData,
    handleClose,
  } = useNdcStrategyEditModal({ toggleVisibility });

  const DropDownItemTemplate = (option: { name: string; code: string }) => {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ marginRight: '0.6rem' }}>{option.name}</div>
        {!checkIfNDCStrategyEditEnabled(
          option.code as NDCFormFieldsTypes,
          userModulesRoles.facts,
          userModulesRoles
        ) && (
          <img
            src={LockIcon}
            alt={'Locked'}
            style={{ height: '17px', width: '17px', padding: 0 }}
          />
        )}
      </div>
    );
  };

  return (
    <Dialog
      blockScroll
      resizable={false}
      draggable={false}
      header={`Edit NDC - ${selectedNdcRowData?.NDC11} `}
      headerClassName={classes.modalHeader}
      visible={visibility}
      style={{ width: '55vw' }}
      onHide={() => {
        if (!visibility) return;
        handleClose();
      }}
    >
      <div className={classes.modalContainer}>
        <Divider className={classes.devider} />
        <div className={classes.updateTooltip}>
          <span className={classes.tooltipMessage}>
            * Fields for which start date is in future, will only be visible in future
          </span>
          <Dropdown
            optionDisabled={checkIfDropdownOptionDisabled}
            itemTemplate={DropDownItemTemplate}
            options={allDropdownOptions()}
            optionLabel="name"
            onChange={e => {
              handleStrategySelect(e.target.value.code);
            }}
            placeholder="Select strategy"
          />
        </div>
        {isAnyStrategySelected() ? (
          <>
            {ndcStrategyIndividualEditData && initialNdcStrategyIndividualEditData && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                {formFieldsArrayConverter().map((fieldValues, index) => {
                  return (
                    <>
                      {fieldValues.selected && fieldValues.keyName !== 'PPSSC' ? (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.5rem',
                            width: '100%',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                            }}
                          >
                            <span>
                              {fieldValues.keyName === 'PPS'
                                ? 'PPS & PPS Reason'
                                : fieldValues.keyName === 'DPStrategy'
                                  ? 'Demand Planning'
                                  : 'Financial Segmentation'}
                            </span>
                            <img
                              style={{ cursor: 'pointer' }}
                              src={MinusIcon}
                              alt="Remove"
                              onClick={() => handleUnselectStrategy(fieldValues.keyName)}
                            />
                          </div>
                          <div style={{ display: 'flex', gap: '0.5rem', width: '100%' }}>
                            <div style={{ width: '50%' }}>
                              <div style={{ width: '100%' }} className={classes.valuesContainer}>
                                <Dropdown
                                  disabled={true}
                                  style={{ width: '100%' }}
                                  key={index}
                                  value={selectedOption(fieldValues.keyName, fieldValues.value)}
                                  options={
                                    convertNdcFormDataToAllOptions(
                                      ndcFormDropDownData as NDCEditFormDropDownResponseInterface
                                    )[fieldValues.keyName]
                                  }
                                  optionLabel="name"
                                  placeholder="Select strategy"
                                />
                              </div>
                            </div>
                            <div style={{ width: '50%' }}>
                              {fieldValues.keyName === 'PPS' && (
                                <div style={{ width: '100%' }} className={classes.valuesContainer}>
                                  <Dropdown
                                    disabled={true}
                                    style={{ width: '100%' }}
                                    key={index}
                                    value={selectedOption(
                                      'PPSSC',
                                      ndcStrategyIndividualEditData.PPSSC.value
                                    )}
                                    options={
                                      convertNdcFormDataToAllOptions(
                                        ndcFormDropDownData as NDCEditFormDropDownResponseInterface
                                      )['PPSSC']
                                    }
                                    optionLabel="name"
                                    placeholder="Select strategy"
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <div style={{ width: '100%' }}>
                              {!fieldValues.monthYearDates ? (
                                <Calendar
                                  style={{ width: '100%' }}
                                  className={classes.dateInput}
                                  value={DateConversionUtility.convertDBDateToLocal(
                                    ndcStrategyIndividualEditData[fieldValues.keyName].startDate
                                  )}
                                  disabled={true}
                                  showIcon
                                />
                              ) : (
                                <Calendar
                                  style={{ width: '100%' }}
                                  view="month"
                                  dateFormat="mm/yy"
                                  className={classes.dateInput}
                                  value={DateConversionUtility.convertDBDateToLocal(
                                    ndcStrategyIndividualEditData[fieldValues.keyName].startDate
                                  )}
                                  disabled={true}
                                  showIcon
                                />
                              )}
                            </div>
                            <div style={{ width: '100%' }}>
                              {!fieldValues.monthYearDates ? (
                                <Calendar
                                  style={{ width: '100%' }}
                                  className={classes.dateInput}
                                  minDate={getTomorowsDate()}
                                  onChange={e =>
                                    formUpdateMethods.handleUpdateEndDate(
                                      fieldValues.keyName,
                                      e.target.value as Date
                                    )
                                  }
                                  value={DateConversionUtility.convertDBDateToLocal(
                                    ndcStrategyIndividualEditData[fieldValues.keyName].endDate
                                  )}
                                  disabled={fieldValues.datesDisabled ? true : false}
                                  showIcon
                                />
                              ) : (
                                <Calendar
                                  style={{ width: '100%' }}
                                  view="month"
                                  dateFormat="mm/yy"
                                  className={classes.dateInput}
                                  minDate={getNextMonthFirstDay(new Date().toDateString())}
                                  onChange={e =>
                                    formUpdateMethods.handleUpdateEndDate(
                                      fieldValues.keyName,
                                      e.target.value as Date
                                    )
                                  }
                                  value={DateConversionUtility.convertDBDateToLocal(
                                    ndcStrategyIndividualEditData[fieldValues.keyName].endDate
                                  )}
                                  disabled={fieldValues.datesDisabled ? true : false}
                                  showIcon
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </>
                  );
                })}
              </div>
            )}
          </>
        ) : (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '3rem',
              width: '100%',
              border: '1px solid grey',
              borderRadius: '0.3rem',
            }}
          >
            <span>Please select some strategy to edit</span>
          </div>
        )}

        {errorDetails.isError && (
          <div className={classes.errorDetails}>{`* ${errorDetails.errorDetails}`}</div>
        )}
        <div className={classes.updateButtonWrapper}>
          <Button
            onClick={toggleHistoryVisibility}
            outlined
            className={classes.historicalButton}
            label="Historical/Future values"
          />
          <Button
            loading={isNdcUpdating || isNdcHistoryLoading}
            disabled={
              !isAnyStrategySelected() || isNdcUpdating || isNcdTableLoading || isNdcHistoryLoading
            }
            className={classes.updateButton}
            onClick={formUpdateMethods.handleUpdateButtonClick}
          >
            Update
          </Button>
        </div>
        {extendedSuccessPopUpVisibility && (
          <ExtendedNdcSuccessPopup
            visibility={extendedSuccessPopUpVisibility}
            toggleVisibility={toggleExtendSuccessNdcPopUpVisibility}
            addedFutureTmsData={extendedSuccessPopUpData}
          />
        )}
        {isHistoryVisible && <NdcHistoryTable />}
      </div>
    </Dialog>
  );
};

export default observer(NDCEditModal);
